import { InfoCircleOutlined } from '@ant-design/icons';
import { theme } from 'antd';
import React from 'react';
import { Button, Flex, Modal, Typography } from 'zui/Antd';
const { Text } = Typography;

const DeleteModalButton = ({
	title = 'Log Out',
	description = 'Are you sure you want to log out?',
	cancelText = 'Cancel',
	okText = 'Log Out',
	icon,
	handleOk,
	handleCancel,
	children,
	open,
	setOpen
}) => {
	const {
		token: { colorWarning, marginSM, marginLG, marginXS, marginXXS, fontSizeHeading3, fontSizeLG }
	} = theme.useToken();

	const showModal = () => {
		setOpen(true);
	};

	return (
		<>
			{children ? (
				children
			) : (
				<Button type='primary' onClick={showModal}>
					Open Modal
				</Button>
			)}
			<Modal
				open={open}
				width={400}
				mask={false}
				closeIcon={false}
				centered
				bodyProps={{
					style: {
						margin: `${marginSM}px ${marginXS}px ${marginLG}px`
					}
				}}
				onCancel={handleCancel}
				footer={[
					<Flex
						justify='end'
						gap={8}
						style={{
							margin: `0px ${marginXS}px ${marginXXS}px`
						}}
					>
						<Button key='cancel' onClick={() => handleCancel()}>
							{cancelText}
						</Button>
						<Button key='logout' type='primary' onClick={handleOk}>
							{okText}
						</Button>
					</Flex>
				]}
			>
				<Flex gap={16} align='start'>
					{icon ? (
						icon
					) : (
						<InfoCircleOutlined
							style={{
								fontSize: fontSizeHeading3,
								color: colorWarning,
								transform: {
									rotate: 'rotate(90deg)'
								}
							}}
						/>
					)}
					<Flex vertical gap={8}>
						<Text strong style={{ fontSize: fontSizeLG, lineHeight: `${fontSizeHeading3}px` }}>
							{title}
						</Text>
						<Text>{description}</Text>
					</Flex>
				</Flex>
			</Modal>
		</>
	);
};

export default DeleteModalButton;
